import { useRef } from "react";
import { motion } from "framer-motion";
import { IMG, LINKS, PRESS } from "../../data/site";
import { Eyebrow, Photo, Reveal, TextLink, useParallax } from "./primitives";
import PressMarquee from "./PressMarquee";

export default function About() {
  const ref = useRef(null);
  const y = useParallax(ref, ["8%", "-8%"]);
  return (
    <section id="about" aria-labelledby="about-title" data-testid="about-section" className="scroll-mt-24 bg-sand px-6 pb-16 pt-24 sm:px-8 lg:px-12 lg:pt-36">
      <div className="mx-auto grid max-w-7xl items-center gap-16 lg:grid-cols-12 lg:gap-16">
        <div ref={ref} className="relative pb-20 lg:col-span-6">
          <Reveal y={40} className="overflow-hidden rounded-[2rem]">
            <div className="aspect-[4/3]">
              <Photo img={IMG.meditate2} sizes="(min-width:1024px) 45vw, 92vw" className="h-full w-full object-cover" data-testid="about-image-main" />
            </div>
          </Reveal>
          <motion.div style={{ y }} className="absolute bottom-0 left-4 w-[48%] max-w-[280px] sm:left-8">
            <div className="overflow-hidden rounded-[1.5rem] border-[6px] border-sand shadow-[0_30px_60px_-30px_rgba(43,38,32,0.55)]">
              <div className="aspect-[4/3]">
                <Photo img={IMG.handstand} sizes="280px" className="h-full w-full object-cover" data-testid="about-image-handstand" />
              </div>
            </div>
          </motion.div>
        </div>

        <div className="lg:col-span-6">
          <Reveal>
            <Eyebrow>About Jake</Eyebrow>
            <h2 id="about-title" className="mt-5 font-display text-[2.4rem] font-light leading-[1.05] text-ink sm:text-5xl lg:text-[3.6rem]">
              An embodiment guide with over 20 years of experience.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-7 text-base leading-relaxed text-ink-soft sm:text-lg">
              I've spent over 20 years working in yoga, fitness and wellness, guiding people through movement, breath, touch and stillness. Not to fix them but to help them reconnect to what's already there.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <blockquote className="mt-9 border-l-2 border-coral pl-6 font-display text-2xl italic leading-snug text-ink sm:text-[1.75rem]">
              “When we come out of the noise of the mind and back into the body, everything begins to shift.”
            </blockquote>
          </Reveal>
          <Reveal delay={0.3} className="mt-9 flex flex-wrap gap-x-8 gap-y-1">
            <TextLink href={LINKS.bio} testid="about-bio-link">Read Jake's story</TextLink>
            <TextLink href={LINKS.training} testid="about-training-link">Training & Experience</TextLink>
          </Reveal>
        </div>
      </div>

      <Reveal className="mx-auto mt-20 max-w-7xl border-t border-ink/10 pt-8 lg:mt-28">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:gap-10" data-testid="press-ribbon">
          <p className="shrink-0 text-[11px] font-semibold uppercase tracking-[0.28em] text-ink-soft">As seen on</p>
          <PressMarquee names={PRESS} />
        </div>
      </Reveal>
    </section>
  );
}
